module.exports = __webpack_public_path__ + "img/compare.a721e28e.png";